import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { themes } from './theme';

const ThemeContext = createContext();

export const useThemeManager = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeManager must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [currentThemeKey, setCurrentThemeKey] = useState(() => {
    return localStorage.getItem('site_theme') || 'exclusive';
  });

  const [currentTheme, setCurrentTheme] = useState(themes[currentThemeKey] || themes.exclusive);

  useEffect(() => {
    setCurrentTheme(themes[currentThemeKey] || themes.exclusive);
    localStorage.setItem('site_theme', currentThemeKey);
  }, [currentThemeKey]);

  const switchTheme = (themeKey) => {
    if (themes[themeKey]) {
      setCurrentThemeKey(themeKey);
    }
  };

  return (
    <ThemeContext.Provider value={{ currentThemeKey, switchTheme, themes }}>
      <StyledThemeProvider theme={currentTheme}>
        {children}
      </StyledThemeProvider>
    </ThemeContext.Provider>
  );
};
